import { observer } from 'mobx-react';
import { MouseEvent } from 'react';
import styled from 'styled-components';

// Components
import AccountDropdown from 'components/headers/AccountDropdown';
import { Layout } from 'top-component-library';

// Constants
import breakpoints from 'constants/breakpoints';
import { header } from 'constants/style';

// Hooks
import { useStores } from 'hooks/use-stores';

// Tracking
import { bosLandingPageTrackingEvents } from 'integrations/segment/tracking-events';

function LandingPageHeader({ className }: { className?: string }) {
  const { hostStore } = useStores();
  const { assets } = hostStore;

  const handleTrackClickGoToHome = (e: MouseEvent): void =>
    bosLandingPageTrackingEvents.trackClickCustomerHomeLinkLandingPage({
      href: assets?.home_button_link,
    });

  return (
    <Header className={className}>
      <Logo src={assets?.landing_page_logo} />
      <Links>
        {assets?.home_button_text && assets?.home_button_link && (
          <HomeRedirect href={assets?.home_button_link} onClick={handleTrackClickGoToHome}>
            {assets?.home_button_text}
          </HomeRedirect>
        )}
        <AccountDropdown />
      </Links>
    </Header>
  );
}

export default observer(LandingPageHeader);

const Header = styled(Layout.Header)`
  align-items: center;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.15);
  display: flex;
  height: ${header.mobile.height}px;
  justify-content: space-between;
  padding: 0.875rem 1rem;
  position: relative;
  z-index: 1;

  @media (min-width: ${breakpoints.md}px) {
    background-color: transparent;
    box-shadow: none;
    height: ${header.desktop.height}px;
    padding: 1.25rem 2rem;
  }
`;

const HomeRedirect = styled.a`
  cursor: pointer;
  font-weight: bold;
  position: relative;
`;

const Links = styled.div`
  display: flex;

  > div:not(:last-child),
  > a:not(:last-child) {
    margin-right: 1rem;
  }
`;

const Logo = styled.img`
  height: 100%;
  object-fit: cover;
  width: auto;
`;
